import Panel from './panel';

const SHARE_BASE = 'https://ar-share.micpn.com/uploaded';

export default class SharePagePanel extends Panel {
  render() {
    this.parent.sendEvent('social_pageview');

    const shareImage = this.getTag('share-page-image');

    if (shareImage) {
      const { element } = shareImage;
      const imageID = this.parent.param('i', { required: true });
      const type = this.parent.param('type', { defaultValue: 'image' });

      const extension = type === 'video' ? 'gif' : 'jpg';

      const newImg = document.createElement('img');
      newImg.style.width = '100%';
      newImg.setAttribute('src', `${SHARE_BASE}/${imageID}.${extension}`);

      element.style.overflow = 'hidden';
      element.appendChild(newImg);
    }

    const bg = this.getTag('background');
    if (bg) {
      const { element } = bg;

      if (!element.style.backgroundImage) {
        document.body.style.backgroundColor = element.style.backgroundColor;
      }
    }

    const arClickthrough = this.getTag('ar-clickthrough');
    if (arClickthrough && arClickthrough.toolProperties.url === 'auto') {
      const link = arClickthrough.element.querySelector('a');
      if (link) {
        link.href = document.location.toString().replace(/&?share_page=[^&]*/, '');
      }
    }

    if (arClickthrough) {
      // App sets up _all_ links to fire a 'share' event; we want to override that

      arClickthrough.element.addEventListener('click', () => {
        this.parent.sendEvent('social_click');
      });
    }
  }
}
